import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import { Button, IconButton } from "@mui/material";
import WebpImage from "@src/component/base/WebpImage";
import useUser from "@src/hook/useUser";
import { GroupA } from "@src/ruix";
import { useRouter } from "next/router";
import { useState } from "react";
import MainMobileMenu from "./MainMobileMenu";

interface MainGnbProps {
	type: "client" | "expert" | "none";
	noBanner?: boolean;
}

export const MainGnbMobile = (props: MainGnbProps) => {
	const { type, noBanner } = props;
	const { user } = useUser();

	const router = useRouter();

	const [hideMobileMenu, setHideMobileMenu] = useState(true);

	const handleOnClickMenu = () => {
		setHideMobileMenu(!hideMobileMenu);
	};

	return (
		<>
			<MainMobileMenu
				pro={type === "expert" ? true : false}
				hidden={hideMobileMenu}
				onClose={handleOnClickMenu}
			/>

			<MainGnbContainer className="row-center-center">
				<div
					className="row-center-between"
					style={{
						width: "100%",
						maxWidth: "944px",
					}}
				>
					<GroupA order="row-center-between" gap={10}>
						<a href="/">
							<WebpImage
								style={{
									width: "110px",
									marginRight: "32px",
								}}
								src="/onepoint/assets/images/logo/h-logo.png"
							/>
						</a>
					</GroupA>
					<GroupA order="row-center-between">
						<IconButton
							size="large"
							edge="start"
							color="inherit"
							aria-label="menu"
							onClick={handleOnClickMenu}
						>
							<MenuIcon
								sx={{
									fill: "white",
								}}
							/>
						</IconButton>
					</GroupA>
				</div>
			</MainGnbContainer>
			{type === "client" && !noBanner ? (
				<Banner
					className="row-center-between"
					id="banner-close"
					onClick={() => {
						window.open(
							"https://docs.channel.io/onepoint/ko/articles/1286c10a-%EB%A6%AC%EC%8A%A4%ED%81%AC%ED%94%84%EB%A6%AC-%EC%A0%95%EC%B1%85-%EC%95%88%EB%82%B4",
						);
					}}
				>
					<div></div>
					<div className="text">
						🎉리스크프리 프로그램!{" "}
						<span style={{ fontWeight: 800 }}>전문가 불만족시 100% 환불!</span>✨
					</div>
					<CloseIcon
						style={{
							fill: "white",
							cursor: "pointer",
							width: "20px",
							height: "20px",
						}}
						onClick={(e) => {
							e.stopPropagation();
							document.getElementById("banner-close")!.style.display = "none";
						}}
					/>
				</Banner>
			) : null}
		</>
	);
};

const Banner = styled.div`
	width: 100%;
	background-color: var(--primary);
	padding: 6px;
	position: sticky;
	top: 60px;
	z-index: 10000;
	cursor: pointer;

	.text {
		color: white;
		font-size: 14px;
		font-weight: 800;
	}
`;

const GnbMenuButton = styled(Button)`
	min-width: fit-content;
	width: fit-content;
	padding: 0;
	color: #fff;
	text-align: center;
	font-family: Pretendard;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: 130%; /* 18.2px */
	letter-spacing: -0.42px;
	position: relative;

	.beta {
		background-color: var(--primary);
		padding: 3px 8px;
		border-radius: 20px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin-left: 5px;
		margin-right: 0px;

		div {
			font-weight: bold;
			color: white;
			font-size: 10px;
			line-height: 10px;
			text-align: center;
		}
	}
`;

const GnbButton = styled(Button)`
	padding: 4px 8px;
	height: auto;
	width: 50px;
	min-width: 50px;
	font-weight: bold;
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	line-height: 130%;
`;

const MainGnbContainer = styled.div`
	width: 100%;
	min-height: 48px;
	padding: 6px 12px;
	position: sticky;
	background-color: var(--card-bg);
	gap: 10px;
	top: 0;
	z-index: 10000;

	picture {
		display: flex;
	}
`;
